var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 251 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard2",
    x: 0,
    y: 0,
    width: 250.861,
    height: 127.496,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.663,23.722l60.472,0l-30.002,0l0,11.523",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.888,23.722l60.472,0l-30.002,0l0,11.523",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.015,35.245c4.659,0 8.44,3.782 8.44,8.44c0,4.658 -3.781,8.44 -8.44,8.44c0,0 -25.949,0 -47.293,0c-7.307,0 -14.314,2.903 -19.48,8.07c-5.166,5.168 -8.068,12.176 -8.066,19.483c0,0.001 0,0.002 0,0.002c0,5.013 -4.069,9.083 -9.082,9.083l-8.976,0l-9.189,0c-5.013,0 -9.083,-4.07 -9.083,-9.083c0,0 0,-0.001 0,-0.002c0.002,-7.307 -2.899,-14.315 -8.065,-19.483c-5.166,-5.167 -12.174,-8.07 -19.481,-8.07c-20.687,0 -45.457,0 -45.457,0c-4.659,0 -8.44,-3.782 -8.44,-8.44c0,-4.658 3.781,-8.44 8.44,-8.44l184.172,0Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.929,93.702c6.255,0 11.333,5.078 11.333,11.333c0,6.255 -5.078,11.333 -11.333,11.333c-6.255,0 -11.333,-5.078 -11.333,-11.333c0,-6.255 5.078,-11.333 11.333,-11.333Zm0,4.157c3.96,0 7.175,3.216 7.175,7.176c0,3.96 -3.215,7.175 -7.175,7.175c-3.96,0 -7.175,-3.215 -7.175,-7.175c0,-3.96 3.215,-7.176 7.175,-7.176Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.929,
    cy: 105.035,
    r: 3.207,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.136,92.18c0,-0.782 -0.635,-1.417 -1.417,-1.417l-3.58,0c-0.782,0 -1.417,0.635 -1.417,1.417l0,2.835c0,0.782 0.635,1.417 1.417,1.417l3.58,0c0.782,0 1.417,-0.635 1.417,-1.417l0,-2.835Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/drone.0cba8fa5fad2a5e3d23a9f69d6de2ab0.svg";
export { ForwardRef as ReactComponent };